export const defaultThemeSaaS = {
	brandPrimary: '#000000',
	brandSecondary: '#3F51B5',
	headerBg: '#000000',
	headerText: '#FFFFFF',
	btnPrimaryBg: '#000000',
	btnPrimaryText: '#FFFFFF',
};

export const defaultTheme = {
	...defaultThemeSaaS,
	btnInfoBg: '#62B1F6', // secondary button
	btnInfoText: '#FFFFFF',
	btnSuccessBg: '#5CB85C', // tertiary button
	btnSuccessText: '#FFFFFF',
};

export const defaultThemeSaaSJSON = JSON.stringify(defaultThemeSaaS);
export const defaultThemeJSON = JSON.stringify(defaultTheme);

export const unusedColorVars = [
	'brandInfo',
	'brandWarning',
	'brandSuccess',
	'brandDanger',
	'toolbarBtnTextColor',
	'listBorderColor',
	'listDividerBg',
	'listNoteColor',
	'inverseTextColor',
	'subtitleColor',
	'containerBgColor',
	'listItemSelected',
	'textColor',
	'brandLight',
	'brandDark',
	'btnDangerBg',
	'btnDangerText',
	'btnWarningBg',
	'btnWarningText',
	'btnDarkBg',
	'btnDarkText',
	'btnLightBg',
	'btnLightText',
	'navBg',
	'navIconAndText',
];
